/*
 * @Author: your name
 * @Date: 2020-09-29 13:14:43
 * @LastEditTime: 2021-03-16 17:10:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \project\src\assets\js\common.js
 */
import Vue from 'vue'
Vue.filter("timeChange", function (UTCDateString) { //保留小数位，acc为保留几位小数位
  if (!UTCDateString || UTCDateString == "-") {
    return "-";
  }

  function formatFunc(str) {
    return str > 9 ? str : "0" + str;
  }
  var date2 = new Date(UTCDateString);
  var year = date2.getFullYear();
  var mon = formatFunc(date2.getMonth() + 1);
  var day = formatFunc(date2.getDate());
  var hour = date2.getHours();

  var noon = hour >= 12 ? "PM" : "AM"; // 判断是上午还是下午
  // hour = hour >= 12 ? hour + 12 : hour; // 12小时制
  hour = formatFunc(hour);
  var min = formatFunc(date2.getMinutes());
  var sec = formatFunc(date2.getSeconds());
  // var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + sec;
  var dateStr = year + "-" + mon + "-" + day + ' ' + hour + ':' + min;
  return dateStr;
});
Vue.filter("timeChange1", function (UTCDateString) { //保留小数位，acc为保留几位小数位
  if (!UTCDateString || UTCDateString == "-") {
    return "-";
  }

  function formatFunc(str) {
    return str > 9 ? str : "0" + str;
  }
  var date2 = new Date(UTCDateString);
  var year = date2.getFullYear();
  var mon = formatFunc(date2.getMonth() + 1);
  var day = formatFunc(date2.getDate());
  var hour = date2.getHours();
  var noon = hour >= 12 ? "PM" : "AM"; // 判断是上午还是下午
  hour = hour >= 12 ? hour - 12 : hour; // 12小时制
  hour = formatFunc(hour);
  var min = formatFunc(date2.getMinutes());
  var sec = formatFunc(date2.getSeconds());
  // var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + sec;
  var dateStr = year + "-" + mon;
  return dateStr;
});
/**
 * 手机号码验证
 */
export function mobileTest(num) {
  const reg = /^1\d{10}$/
  return reg.test(num)
}
/**
 *邮箱校验
 *
 */
export function emailTest(email) {
  // const reg = /^[A-Za-z0-9]+@([_A-Za-z0-9]+\.)+[A-Za-z0-9]{2,3}$/
  const reg = /@/
  return reg.test(email)
}
/**
 *
 * 验证密码 密码， 长度在6~18 之间， 包含字母、 数字
 */
export function isvalidPass(str) {
  const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/;
  return reg.test(str);
}
// 按照属性排序
export function compare(property) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value2 - value1;
  }
}
// 去重排序
export function norepeatSort(arr, arr2) {
  //第一步去重
  for (var i = 0; i < arr.length; i++) {
    arr2.indexOf(arr[i]) == -1 ? arr2.push(arr[i]) : '';
  }
  //第二步排序
  arr2.sort(function (a, b) {
    return a - b;
  })
  return arr2;
}
/**
 * 手机号中间4位隐藏
 */
export function hidden(val) {
  const reg = getRegExp('^(\d{3})\d{4}(\d{4})$')
  // return item.replace(reg, "$1****$2")
  return reg.test(val)
}
/**
 *下载文件到本地
*/
export async function downLoadFiles(fileName, file) {
  // 1
  var a = document.createElement("a");
  a.download = fileName;
  var reg = RegExp(/(jpg|jpeg|png|pdf|gif)/);
  if (fileName.match(reg)) {
    a.target = '_blank'
  }
  a.href = file;
  document.body.appendChild(a); // 修复firefox中无法触发click
  a.click();
  document.body.removeChild(a);
}
/**
 *即将超时和已超时
*/
export function time(timer, taskList, startTime, _this) {
  timer = setInterval(() => {
    var y = new Date().getTime() / 1000;

    taskList.forEach((item, index) => {
      startTime = new Date(item.createTime).getTime() / 1000 // 除以1000是转换为秒
      let a = new Date(item.createTime)
      let b = new Date(item.createTime)
      item.threeTime = (a.setDate(a.getDate() + 3)) / 1000 // 3天后的时间戳
      item.fiveTime = (b.setDate(b.getDate() + 5)) / 1000 //5天后的时间戳
      item.defferTime = parseInt(y - startTime)
      item.defferTime3 = parseInt(item.threeTime - startTime)
      item.defferTime5 = parseInt(item.fiveTime - startTime)
      item.y = y
      if ((item.defferTime >= item.defferTime3) && (item.defferTime < item.defferTime5) && item.applyStatus == 2) {
        // var soontime = []
        // var soontime = parseInt(this.fiveTime - this.nowTime)// 即将超时剩余时间
        item.soontimeNew = parseInt(item.fiveTime - y)

        // this.soonTimer = setInterval(() => {
        var days = parseInt(item.soontimeNew / (24 * 60 * 60), 10); //计算剩余的天数

        var hours = parseInt((item.soontimeNew / (60 * 60)) % 24, 10); //计算剩余的小时

        var minutes = parseInt((item.soontimeNew / 60) % 60, 10); //计算剩余的分钟

        var seconds = parseInt(item.soontimeNew % 60, 10); //计算剩余的秒数
        item.soonTimeOutDay = days + '天' + hours.toString().padStart(2, '0') + "时"
        item.soonTimeOut = days + "天" + hours.toString().padStart(2, '0') + "时" + minutes.toString().padStart(2, '0') + "分" + seconds.toString().padStart(2, '0') + "秒"
        //   --time
        // }, 1000);
      } else if ((item.defferTime >= item.defferTime5) && item.applyStatus == 3) {
        // var time = parseInt(this.nowTime - this.fiveTime)
        item.outtimeNew = parseInt(y - item.fiveTime)

        var days = parseInt(item.outtimeNew / (24 * 60 * 60), 10); //计算剩余的天数

        var hours = parseInt((item.outtimeNew / (60 * 60)) % 24, 10); //计算剩余的小时

        var minutes = parseInt((item.outtimeNew / 60) % 60, 10); //计算剩余的分钟

        var seconds = parseInt(item.outtimeNew % 60, 10); //计算剩余的秒数
        item.timeOutDay = days + '天' + hours.toString().padStart(2, '0') + "时"
        item.lastTime = days + "天" + hours.toString().padStart(2, '0') + "时" + minutes.toString().padStart(2, '0') + "分" + seconds.toString().padStart(2, '0') + "秒"

      }

    })
    _this.$forceUpdate()
  }, 1000);

}